import React, { Component } from 'react';
import { Container, Row, Col, Card, CardTitle, CardText, CardBlock } from 'reactstrap';

export default class Perros extends Component {
  render() {
    return (
        <Container>
          <Row>
            <Col xs="8">
                <Card>
                  <CardBlock>
                    <CardTitle>Perros</CardTitle>
                    <CardText>
                        El perro o perro doméstico (Canis lupus familiaris) o también llamado can es un mamífero carnívoro de la familia de los cánidos, que constituye una subespecie del lobo (Canis lupus). Un estudio publicado por la revista Nature revela que, gracias al proceso de domesticación, el organismo del perro se ha adaptado6 a cierta clase de alimentos, en este caso el almidón.7 Su tamaño o talla, su forma y pelaje es muy diverso según la raza. Posee un oído y olfato muy desarrollados, siendo este último su principal órgano sensorial. En las razas pequeñas puede alcanzar una longevidad de cerca de 20 años, con atención esmerada por parte del propietario, de otra forma su vida en promedio es alrededor de los 15 años.
                    </CardText>
                    <CardText>
                      Se cree que el lobo gris, del que es considerado una subespecie, es el antepasado más inmediato. Las pruebas arqueológicas demuestran que el perro ha estado en convivencia cercana con los humanos desde hace al menos 9000 años, pero posiblemente desde hace 14 000 años. Las pruebas fósiles demuestran que los antepasados de los perros modernos ya estaban asociados con los humanos hace 100 000 años. Las investigaciones más recientes indican que el perro fue domesticado por primera vez en el este de Asia, posiblemente en China; sin embargo, se ignora si todos los perros domésticos provienen de un mismo grupo o si el proceso de domesticación se repitió varias veces.
                    </CardText>
                    <CardText>
                      Hay aproximadamente 800 razas —más que de cualquier otro animal— que varían significativamente en tamaño, fisonomía y temperamento, presentando una gran variedad de colores y de tipos de pelo según la raza de perro. Tienen una gran relación con los humanos, para quien son animales de compañía, animales de guardia, perros de trabajo, perros de caza, perros de aguas, galgos de carrera, perros guía, perros pastores o perros boyeros por ejemplo. En 2001, se estimaba que había 400 millones de perros en el mundo.
                    </CardText>
                  </CardBlock>
                </Card>
            </Col>
            <Col>
              <Card block inverse style={{backgroundColor: '#009688', borderColor: '#999'}}>
                <CardBlock>
                  <CardTitle>¿Sabias que?</CardTitle>
                  <CardText>
                    LOS PERROS TIENEN UNA MEMBRANA ESPECIAL EN EL OJO LLAMADA TAPETUM LUCIDUM QUE LES PERMITE VER MEJOR EN LA OSCURIDAD.
                  </CardText>
                </CardBlock>
              </Card>
            </Col>
          </Row>
        </Container>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Perros/index.js